import React, { useMemo, useState } from "react";
import { MapPin, Search, ChevronDown } from "lucide-react";

/*
  Only Nigeria location mappings existed in the supplied code.
  Do not invent Kenya/Ghana mappings until the backend/search contract
  for those locations is confirmed.
*/
const LOCATION_OPTIONS = {
  NG: [
    { label: "All Locations", value: null },
    { label: "Lagos, Nigeria", value: "Africa/Lagos" },
    { label: "Abuja, Nigeria", value: "Africa/Lagos" },
    { label: "Port Harcourt, Nigeria", value: "Africa/Lagos" },
    { label: "Ibadan, Nigeria", value: "Africa/Lagos" },
  ],
  KE: [{ label: "All Locations", value: null }],
  GH: [{ label: "All Locations", value: null }],
  GLOBAL: [{ label: "All Locations", value: null }],
};

const SearchHeader = ({
  countryCode = "GLOBAL",
  onSearchChange,
  onLocationChange,
}) => {
  const options = useMemo(
    () => LOCATION_OPTIONS[countryCode] || LOCATION_OPTIONS.GLOBAL,
    [countryCode]
  );

  const [location, setLocation] = useState(options[0]);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleSelect = (option) => {
    setLocation(option);
    setDropdownOpen(false);
    onLocationChange?.(option);
  };

  return (
    <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-4 py-4 bg-white">
      <div className="flex items-center w-full sm:w-[70%] bg-white rounded-full shadow-sm border border-gray-200 px-4 py-2">
        <Search className="w-5 h-5 text-gray-400 mr-2" />

        <input
          type="search"
          placeholder="Search by name, date or location..."
          className="flex-1 bg-transparent outline-none text-sm text-gray-700"
          onChange={(e) => onSearchChange?.(e.target.value)}
          aria-label="Search events"
        />
      </div>

      <div className="relative w-full sm:w-auto">
        <button
          type="button"
          onClick={() => setDropdownOpen((open) => !open)}
          className="w-full sm:w-auto flex items-center justify-between sm:justify-start gap-2 bg-white border border-gray-200 shadow-sm rounded-full px-4 py-2 text-gray-700 hover:bg-gray-50"
          aria-expanded={dropdownOpen}
        >
          <MapPin className="w-5 h-5 text-gray-500" />
          <span className="text-sm font-medium">{location.label}</span>
          <ChevronDown className="w-4 h-4 ml-1 text-gray-400" />
        </button>

        {dropdownOpen && (
          <div className="absolute right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg w-full sm:w-56 z-30 overflow-hidden">
            {options.map((option) => (
              <button
                type="button"
                key={option.label}
                onClick={() => handleSelect(option)}
                className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${
                  option.label === location.label
                    ? "bg-gray-100 font-medium"
                    : ""
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchHeader;
